import { Modal } from 'antd';
import { X } from 'lucide-react';

interface FluxoCaixaModalShellProps {
  open: boolean;
  onCancel: () => void;
  eyebrow: string;
  title: string;
  width?: number;
  children: React.ReactNode;
}

export function FluxoCaixaModalShell({
  open,
  onCancel,
  eyebrow,
  title,
  width = 560,
  children,
}: FluxoCaixaModalShellProps) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={false}
      width={width}
      destroyOnHidden
      centered
      className="meta-modal"
      styles={{
        mask: { background: 'rgba(0, 0, 0, 0.45)' },
        body: { padding: 0, overflow: 'hidden' },
      }}
      zIndex={1000}
    >
      <button
        type="button"
        onClick={onCancel}
        className="absolute top-4 right-4 z-50 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-zinc-800 text-gray-500 dark:text-gray-400 transition"
        aria-label="Fechar"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="flex flex-col h-auto bg-white dark:bg-zinc-900">
        <div className="bg-[#0d0d0f] dark:bg-zinc-800 text-white px-6 py-4 flex-shrink-0">
          <p className="text-[11px] text-white/50 uppercase tracking-wide mb-1">{eyebrow}</p>
          <h2 className="text-[15px] font-semibold">{title}</h2>
        </div>

        <div className="px-6 py-6 flex-1 overflow-y-auto">{children}</div>
      </div>
    </Modal>
  );
}
